
//impoprtar modulos
import { NgModule, ModuleWithProviders, Component } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


@NgModule({
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
//importar componentes
import { LoginComponent } from '../components/login.component';
import { MenuComponent } from '../components/menu.component';
import { HomeComponent } from '../components/home.component';
import { FormularioPaciente } from '../components/crearpaciente.component';
import { ListaPacientesComponent } from '../components/listapacientes.component';
import { HistorialComponent } from '../components/historial.component';
import { EditPacientesComponent } from '../components/editor.component';

// creacion de rutos
const AppRoutes: Routes = [
  {path : '' , component : LoginComponent},
  {path : 'login' , component : LoginComponent },
  {path: 'editar/:id', component : EditPacientesComponent },
  {path: 'detalle/:id', component : HistorialComponent },
  {path : 'home', component : HomeComponent},
  {path: 'formulariopaciente', component : FormularioPaciente },
  {path: 'buscarpaciente', component :ListaPacientesComponent },
  {path:'**', component: LoginComponent}
];

export const AppRoutingProviders: any [] = [];

export const Routing: ModuleWithProviders = RouterModule.forRoot(AppRoutes);
/*********************************************************************************************************************
 Construido y distribuido por IT-SolutionsSpa, soluciones informáticas para su negocio 
Santiago, Chile 2019,
Ingeniero de Software FrontEnd: Rodrigo Neira
Ingeniero de Software BackEnd: Octavio Cubillos
Gestor: Edison Núñez
mayor informacion a contacto@itsolutonsspa.cl
o en www.itsolutionsspa.cl 
 ********************************************************************************************************************/